import { PedidoClicheriaStatusID } from './pedido-clicheria-status.id';

/** Status da clicheria */
export interface PedidoClicheriaStatus {
    id: PedidoClicheriaStatusID;
    nome: string;
    descricao: string;
    icon: string;
}

export namespace PedidoClicheriaStatus {
    /** Status Desenvolver Arte */
    export const STATUS_DESENVOLVER_ARTE: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.DESENVOLVER_ARTE,
        nome: 'Desenvolver Arte',
        descricao: 'Arte em desenvolvimento',
        icon: 'fas fa-palette'
    };

    /** Status Aprovar Arte */
    export const STATUS_APROVAR_ARTE: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.APROVAR_ARTE,
        nome: 'Aprovar Arte',
        descricao: 'Arte aguardando aprovação',
        icon: 'fas fa-check-circle'
    };

    /** Status Arte Reprovada */
    export const STATUS_ARTE_REPROVADA: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.ARTE_REPROVADA,
        nome: 'Arte Reprovada',
        descricao: 'Arte foi reprovada',
        icon: 'fas fa-times-circle'
    };

    /** Status Revisar Clichê */
    export const STATUS_REVISAR_CLICHE: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.REVISAR_CLICHE,
        nome: 'Revisar Clichê',
        descricao: 'Clichê em revisão',
        icon: 'fas fa-search-plus'
    };

    /** Status Inutilizar Clichê */
    export const STATUS_INUTILIZAR_CLICHE: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.INUTILIZAR_CLICHE,
        nome: 'Inutilizar Clichê',
        descricao: 'Clichê será inutilizado',
        icon: 'fas fa-trash'
    };

    /** Status Arte Aprovada */
    export const STATUS_ARTE_APROVADA: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.ARTE_APROVADA,
        nome: 'Arte Aprovada',
        descricao: 'Arte foi aprovada',
        icon: 'fas fa-check'
    };

    /** Status Solicitada Alteração Arte */
    export const STATUS_SOLICITADA_ALTERACAO_ARTE: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.SOLICITADA_ALTERACAO_ARTE,
        nome: 'Solicitada Alteração Arte',
        descricao: 'Alteração de arte solicitada',
        icon: 'fas fa-edit'
    };

    /** Status Outro */
    export const STATUS_OUTRO: PedidoClicheriaStatus = {
        id: PedidoClicheriaStatusID.OUTRO,
        nome: 'Outro',
        descricao: 'Outro status',
        icon: 'far fa-question-circle'
    };

    /** Retorna todos os status da clicheria */
    export function getAll(): PedidoClicheriaStatus[] {
        return [
            STATUS_DESENVOLVER_ARTE,
            STATUS_APROVAR_ARTE,
            STATUS_ARTE_REPROVADA,
            STATUS_REVISAR_CLICHE,
            STATUS_INUTILIZAR_CLICHE,
            STATUS_ARTE_APROVADA,
            STATUS_SOLICITADA_ALTERACAO_ARTE,
            STATUS_OUTRO
        ];
    }

    /** Obtém o status pelo id */
    export function getById(id: number): PedidoClicheriaStatus | undefined {
        return getAll().find(status => status.id === id);
    }
}
